const menu = {
    label: 'Pagamento de Benefícios',
    icon: 'pi pi-fw pi-sitemap',
    to: '/solicitacoes/pagamento-beneficios',
    matchChildren: true,
    rules: [''],
};

export default menu;